module.exports = __webpack_public_path__ + "static/img/logo.662a0de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/teaser/logo.png
// module id = N6vB
// module chunks = 0